import { createReducer } from '@reduxjs/toolkit';

import { review, withdraw } from '../../change-requests/actions';
import { initializeDiscussion, poll } from '../actions';
import { collectChangeRequests } from '../transform-comment-helpers';

export default createReducer(
  {},
  {
    [initializeDiscussion]: (state, { payload }) =>
      payload.changeRequestsByCommentsId,

    [`${poll}-success`]: (changeRequests, { payload: newComments }) => ({
      ...changeRequests,
      ...collectChangeRequests(newComments),
    }),
    [`${withdraw}-success`]: (
      changeRequests,
      { payload: updatedChangeRequest },
    ) => ({
      ...changeRequests,
      [updatedChangeRequest.commentId]: updatedChangeRequest,
    }),
    [`${review}-success`]: (changeRequests, { payload: updatedApproval }) => {
      const { approval } = updatedApproval;
      const crId = approval?.changeRequest || approval?.changeRequestId;
      const changeRequest = Object.values(changeRequests).find(
        cr => cr.id === crId,
      );
      const approvalIndex = changeRequest.approvals.findIndex(
        item => item.id === approval.id,
      );

      changeRequest.approvals[approvalIndex] = approval;
    },
  },
);
